import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    height: 300,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    gap: SPACES.xxxxxl,
    padding: SPACES.xxxxl,

    outline: 'none',

    [theme.breakpoints.down('tablet')]: {
      minWidth: 340,
    },
    [theme.breakpoints.up('tablet')]: {
      width: 400,
    },
  },
  modalTitle: {
    '&&': {
      fontSize: FONTS.SIZES.xxxxl,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,

      wordBreak: 'break-word',
    },
  },
  formInputsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxl,
  },

  tableIcon: {
    '&&': {
      marginLeft: 2,
      marginRight: 2,
    },
  },
  suspensionIcon: {
    '&&': {
      width: 16,
      height: 16,
      fill: theme.palette.custom.warning,
    },
  },
  tableRow: {
    '&&': {
      borderTop: `1px solid ${theme.palette.custom.grey}`,
      borderBottom: `1px solid ${theme.palette.custom.grey}`,
      cursor: 'pointer',
    },
  },

  selectionAvatar: {
    '&&': {
      width: 30,
      height: 30,
    },
  },
  ownerCircle: {
    '&&': {
      '& .MuiBadge-badge': {
        backgroundColor: theme.palette.custom.primary,
        color: theme.palette.custom.primary,
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          border: '1px solid currentColor',
          content: '""',
        },
      },
    },
  },
  selectionIconButton: {
    '&&': {
      marginRight: '-16px',
    },
  },
  iconsWrapper: {
    marginRight: 16,
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      color: theme.palette.custom.white,
      fontWeight: FONTS.WEIGHTS.semi_bold,
    },
  },
  subtitle: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      color: theme.palette.custom.white,
      fontWeight: FONTS.WEIGHTS.light,
    },
  },
}))

export { useStyles }
